import React, {useEffect} from "react";
import {useForm, Field} from "react-final-form";
import {STATUS_FAILURE, STATUS_SUCCESS, STATUS_UPLOADING} from "../../helpers/FileEntity";
import {deleteFile} from "../../actions/FileActions";
import {useDispatch} from "react-redux";
import PropTypes from "prop-types";
import Error from "./Error";
import TooltipIcon from "../tooltips/TooltipIcon";

function FileNameFiled({name, file, index, validate}) {
    const dispatch = useDispatch();
    const form = useForm()

    form.change(`${name}.[${index}].name`, file.name);
    form.change(`${name}.[${index}].originalName`, file.originalName);
    form.change(`${name}.[${index}].size`, file.source.size);
    form.change(`${name}.[${index}].mimeType`, file.source.type);

    useEffect(() => {
        return () => {
            form.mutators.remove(name, index);
        }
    }, []);

    const handleDeleteFile = file => {
        dispatch(deleteFile(file));
    }

    return <div className="dz-preview dz-file-preview">
        <div className="dz-preview-icons">
            {file.status === STATUS_UPLOADING && (
                <div className="dz-progress">
                    <div className="loader">
                        <svg className="circular-loader" viewBox="25 25 50 50">
                            <circle className="loader-path" cx="50" cy="50" r="20"
                                    fill="none"
                                    strokeWidth="4" strokeDasharray="150, 200"
                                    strokeDashoffset="-10" stroke="#0265FF"
                            />
                        </svg>
                    </div>
                </div>
            )}
            {file.status === STATUS_SUCCESS && (
                <div className="dz-success-mark">
                    <img src="/_core/assets/themes/v5/assets/img/form3/completed.svg" alt=""/>
                </div>
            )}
            {file.status === STATUS_FAILURE && (
                <div className="dz-error-mark">
                    <img src="/_core/assets/themes/v5/assets/img/form3/error.svg" alt=""/>
                </div>
            )}
        </div>
        <div className="dz-details">
            <div className={`dz-filename ${file.status === STATUS_FAILURE ? 'dz-filename-has-error' : ''}`} style={{maxWidth: '145px'}}>
                <TooltipIcon tooltip={file.status === STATUS_FAILURE ? file.message : file.originalName}>
                    {file.originalName}
                </TooltipIcon>
            </div>
        </div>
        <div className={`dz-remove ${file.status === STATUS_FAILURE ? 'dz-remove-has-error' : ''}`} onClick={() => handleDeleteFile(file)}>
            <svg width="9" height="9" viewBox="0 0 9 9" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.16628 0.653925C7.84125 0.3289 7.31421 0.3289 6.98975 0.653925L4.41016 3.23385L1.83057 0.653925C1.50554 0.3289 0.979062 0.3289 0.654037 0.653925C0.329011 0.97895 0.329011 1.50543 0.654037 1.83046L3.23362 4.41027L0.653925 6.99019C0.3289 7.31522 0.3289 7.8417 0.653925 8.16672C0.816382 8.32918 1.02931 8.41052 1.24225 8.41052C1.45518 8.41052 1.66833 8.32929 1.83057 8.16672L4.41016 5.58691L6.98975 8.16672C7.1522 8.32918 7.36513 8.41052 7.57807 8.41052C7.791 8.41052 8.00382 8.32929 8.16639 8.16672C8.49141 7.8417 8.49141 7.31522 8.16639 6.99019L5.58669 4.41038L8.16628 1.83057C8.4913 1.50554 8.4913 0.97895 8.16628 0.653925Z"
                    fill="#56657B"
                />
            </svg>
        </div>

        <Field name={`${name}.[${index}].name`} type="hidden" component="input" validate={validate} />
        <Error name={`${name}.[${index}].name`} />

        <Field name={`${name}.[${index}].originalName`} type="hidden" component="input" />
        <Field name={`${name}.[${index}].size`} type="hidden" component="input" />
        <Field name={`${name}.[${index}].mimeType`} type="hidden" component="input" />
    </div>
}

FileNameFiled.propTypes = {
    name: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    file: PropTypes.object.isRequired,
}

export default FileNameFiled;